import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';
import useModal from '../../../../utils/hooks/useModal';

// Icons
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';

// Components
import Button from '../../../atoms/Button/Button';
import CreationForm from './CreationForm/CreationForm';

function AccountCreation({
  tableType, roles, establishmentId, setAdministrators,
}) {
  const { t } = useTranslation();
  const { displayModal } = useModal();

  const accountCreationForm = useRef();

  return (
    <Button
      onClick={() => displayModal({
        maxWidth: 455,
        title: t('admin.creation.title'),
        content: (
          <CreationForm
            ref={accountCreationForm}
            tableType={tableType}
            roles={roles}
            establishmentId={establishmentId}
            setAdministrators={setAdministrators}
          />
        ),
        buttons: [
          {
            label: t('common.cancel'),
            theme: 'inverted',
          },
          {
            label: t('admin.creation.form.submit'),
            onClick: () => accountCreationForm?.current?.submitForm(),
            queryName: 'postAccount',
          },
        ],
      })}
    >
      <PlusIcon className="m-r-10" />
      {t('admin.creation.title')}
    </Button>
  );
}

AccountCreation.propTypes = {
  tableType: PropTypes.string.isRequired,
  roles: PropTypes.arrayOf(PropTypes.shape({})),
  establishmentId: PropTypes.string,
  setAdministrators: PropTypes.func,
};

AccountCreation.defaultProps = {
  roles: [],
  establishmentId: null,
  setAdministrators: () => {},
};

export default AccountCreation;
